import { Model } from "@westpierstudio/luma/mvc";
import { IServiceProvider } from "@westpierstudio/luma/services";
import { SpinType } from "components/reels/ReelsModel";
import { cloneDeep, orderBy } from "lodash";
import { BonusSymbolID, SymbolPos, Win } from "servertypes/SharedTypes";

export interface WinDisplayConfig {
    displayWinTime: number,
    timeBetweenWins: number,
    startHidden?: boolean
}

export class WinlinesModel extends Model {

    private _activeWinDisplayConfig!: WinDisplayConfig;
    private winDisplayConfigs: Map<SpinType, WinDisplayConfig> = new Map();
    private wins: Win[] = [];
    private lineIndex = 0;

    winsContainBonus = false;
    lineCount = 0;

    public get winList(): Win[] {
        return this.wins;
    }

    get activeWinDisplayConfig(): WinDisplayConfig {
        return this._activeWinDisplayConfig;
    }

    constructor(services: IServiceProvider) {
        super(services);

        this.setupWinDisplayConfigs();
    }

    setWinDisplayConfigForSpinType(type: SpinType): WinDisplayConfig {

        this._activeWinDisplayConfig = this.winDisplayConfigs.get(type) as WinDisplayConfig;
        return this._activeWinDisplayConfig;
    }

    storeWins(wins: Win[]): void {

        this.wins = [];
        this.winsContainBonus = false;
        this.lineCount = 0;
        this.lineIndex = 0;

        if (wins.length > 0) {

            this.wins = orderBy(wins, [`moneyWon`], [`desc`]);
            this.lineCount += wins.length;
        }
    }

    storeFreeGameBonusWin(bonusSymbolPositions: SymbolPos[]) {
        const bonusWin = { pattern: bonusSymbolPositions, symbol: BonusSymbolID.B1, coinsWon: -1, moneyWon: -1, oakIndex: 0, usesWild: false, winIndex: -1 };
        this.wins.push(bonusWin);
        this.lineCount++;
        this.winsContainBonus = true;
    }

    firstWinLineData() {
        return this.wins[0];
    }

    nextWinLineData(): Win | undefined {
        if (!this.wins || this.lineIndex === this.lineCount) {
            return;
        }

        return this.wins[this.lineIndex++];
    }

    resetLineIndex(): void {
        this.lineIndex = 0;
    }

    override reset(): void {

        this.wins = [];
        this.lineIndex = 0;
        this.lineCount = 0;
        this.winsContainBonus = false;
    }

    private setupWinDisplayConfigs(): void {

        const configs: Record<SpinType, WinDisplayConfig> = this.services.resources.getSetting(`winDisplayConfigs`);

        for (const [key, value] of Object.entries(configs)) {

            switch (key) {
                case SpinType.REGULAR:
                    this.winDisplayConfigs.set(key, value);
                    break;
                case SpinType.FREE_SPIN:
                case SpinType.TURBO:
                case SpinType.TURBO_FREE_SPIN:
                    this.winDisplayConfigs.set(key, this.makeCustomWinDisplayConfig(configs[SpinType.REGULAR], value));
                    break;
            }
        }
    }

    private makeCustomWinDisplayConfig(defaultValues: Record<string, any>, customValues: Record<string, any>): WinDisplayConfig {

        const customConfig = cloneDeep(defaultValues);

        for (const [key, value] of Object.entries(customValues)) {
            customConfig[key] = value;
        }

        return customConfig as WinDisplayConfig;
    }
}